module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"love":"Made with love at Stageline","hello":"Hello, "},"fr":{"love":"Fait avec amour chez Stageline","hello":"Bonjour, "}}')
  delete Component.options._Ctor
}
